import { FC, useCallback, useEffect, useState } from "react";
import HighCharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import {
  PIE_CHART_OPTIONS,
} from "src/constants/highCharts";
import { wrapperFunctionPieChart } from "src/helpers";
import { pieChartObject } from "./types";



const CustomPieChart: FC<pieChartObject> = ({ pieChartObject,title}): JSX.Element => {
  const [data, setData] = useState({});

  const populatePieChart = useCallback(() => {
    const topPayorOptions = {
      ...PIE_CHART_OPTIONS,
      series: wrapperFunctionPieChart(pieChartObject)
    };
    setData(topPayorOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pieChartObject]);

  useEffect(() => {
    populatePieChart();
  }, [populatePieChart]);

  return (
      <div className="card">
          <div className="card-header">
              <h4 className="m-0">{title}</h4>
          </div>
          <div className="card-body">
              <HighchartsReact highcharts={HighCharts} options={data} />
          </div>
      </div>
  );
};

export default CustomPieChart;



// import { FC, useCallback, useEffect, useState } from "react";
// import HighCharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// import { PIE_CHART_OPTIONS } from "src/constants/highCharts";
// import { pieChartObject } from "./types";

// // Enable drilldown
// if (typeof HighCharts === "object") {
//   drilldown(HighCharts);
// }

// interface ICDChartProps extends pieChartObject {
//   title: string;
// }

// const CustomPieChart: FC<ICDChartProps> = ({ pieChartObject, title }): JSX.Element => {
//   const [options, setOptions] = useState({});

//   const populatePieChart = useCallback(() => {
//     const pieOptions: HighCharts.Options = {
//       ...PIE_CHART_OPTIONS,
//       chart: {
//         type: "pie"
//       },
//       title: { text: title },
//       series: [
//         {
//           type: "pie",
//           name: "ICD Codes",
//           colorByPoint: true,
//           data: pieChartObject.topICDCodes.map((item: any) => ({
//             name: item.icdCode,
//             y: item.value,
//             drilldown: item.icdCode
//           }))
//         }
//       ],
//       drilldown: {
//         series: pieChartObject.topICDCodes.map((item: any) => ({
//           id: item.icdCode,
//           type: "pie",
//           name: `Treatment Areas for ${item.icdCode}`,
//           data: item.treatmentAreas.map((ta: any) => [ta.name, ta.value])
//         }))
//       }
//     };

//     setOptions(pieOptions);
//   }, [pieChartObject, title]);

//   useEffect(() => {
//     populatePieChart();
//   }, [populatePieChart]);

//   return (
//     <div className="card">
//       <div className="card-header">
//         <h4 className="m-0 text-center">{title}</h4>
//       </div>
//       <div className="card-body">
//         <HighchartsReact highcharts={HighCharts} options={options} />
//       </div>
//     </div>
//   );
// };

// export default CustomPieChart;
